import { Link, useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useAuth } from "../../../core/hooks/useAuth";
import { useHandleCourses } from "../../../core/hooks/useHandleCourses";
import {
  convertTimestampToDate,
  formatTime,
} from "../../../core/common/ults/dateTime";
import { useHandleAssign } from "../../../core/hooks/useHandleAssign";
import { useHandleQuiz } from "../../../core/hooks/useHandleQuiz";
import { useState } from "react";
import { Modal, Spin } from "antd";
import { useTranslation } from "react-i18next";

const getStatusText = (status: string, t: any) => {
  switch (status) {
    case "submitted":
      return t("quiz.card.statusText.submitted");
    case "draft":
      return t("quiz.card.statusText.draft");
    case "new":
      return t("quiz.card.statusText.new");
    case "reopened":
      return t("quiz.card.statusText.reopened");
    default:
      return t("quiz.card.statusText.unknown");
  }
};

const QuizCard = ({ data }: any) => {
  console.log(data);
  const { t } = useTranslation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const [showNotOpenModal, setShowNotOpenModal] = useState(false);
  const [assignLoading, setAssignLoading] = useState(false);
  const { moodleUser } = useAuth();
  const { enrolledCourses } = useHandleCourses(moodleUser?.id);
  const {
    statusSubmissions,
    isStatusSubmissions,
    viewAssignMutation,
    creatSubmissionMutation,
  } = useHandleAssign(data?.id);
  const { quizAttemptOverview, startQuiz } = useHandleQuiz(data?.type === "quiz" ? data?.id : null);
  const navigate = useNavigate();
  const lastAttemp =
    quizAttemptOverview?.attempts?.[quizAttemptOverview?.attempts?.length - 1];
  const route = all_routes;

  // chuyển hướng assignquestion nếu type===assign
  // nếu type quiz và finished thì chuyển hướng đến quiz-review, không thì chuyển hướng đến quiz-question để làm bài
  const getRoute = () => {
    if (data?.type === "assignment") {
      return `${route.studentAssignQuestion}/${data.id}`;
    }
    if (lastAttemp?.state === "finished" && data?.type === "quiz") {
      return `${route.studentQuizReview}/${lastAttemp?.id}`;
    }
    return `${route.studentQuizQuestion}/${lastAttemp?.id}`;
  };

  const courseList = Array.isArray(enrolledCourses) ? enrolledCourses : [];
  const courseName =
    courseList.find((course: any) => course.id === data?.course)
      ?.fullname || "Không xác định";

  // modal thông báo chỉ áp dụng với type quiz
  // nếu chưa đến giờ làm bài thì thông báo chưa đến giờ
  // nếu hết hạn và khác finished thì thông báo hết thời gian làm bài
  // nếu lastAttempt trống (bài tập mới tạo) thì popup bắt đầu làm bài
  const handleCardClick = async (e: React.MouseEvent) => {
    if (data?.type === "quiz") {
      // Kiểm tra chưa đến giờ làm bài
      if (isNotOpen() && lastAttemp?.state !== "finished") {
        e.preventDefault();
        setShowNotOpenModal(true);
        return;
      }
      // Kiểm tra hết thời gian làm bài
      if (isExpired() && lastAttemp?.state !== "finished") {
        e.preventDefault();
        setShowExpiredModal(true);
        return;
      }
      if (!lastAttemp) {
        e.preventDefault();
        setShowConfirmModal(true);
      }
    }
    if (data?.type === "assignment") {
      e.preventDefault();
      setAssignLoading(true);
      try {
        await viewAssignMutation.mutateAsync(data.id);
        // Nếu chưa có submission thì tạo submission
        if (!statusSubmissions?.lastattempt?.submission) {
          await creatSubmissionMutation.mutateAsync(data.id);
        }
        // Chờ một chút để đảm bảo backend cập nhật
        setTimeout(() => {
          setAssignLoading(false);
          navigate(`${route.studentAssignQuestion}/${data.id}`, {
            state: {
              allowSubmissionsFromDate: data?.allowsubmissionsfromdate,
              assignDuedate: data?.duedate,
              cmid: data?.cmid,
              quizName: data?.name,
              totalgrade: data?.grade,
              introAssign: data?.intro,
              filesArray: data?.introattachments || [],
              courseName: courseName,
            },
          });
        }, 500);
      } catch (err) {
        setAssignLoading(false);
      }
    }
  };

  const handleStartQuiz = async () => {
    const response = await startQuiz(data?.id);
    setShowConfirmModal(false);
    navigate(`${route.studentQuizQuestion}/${response?.attempt?.id}`, {
      state: {
        quizName: data?.name,
        state: response?.attempt?.state,
        totalgrade: data?.grade,
      },
    });
  };

  // Hàm kiểm tra chưa đến giờ làm bài
  const isNotOpen = () => {
    if (!data?.timeopen || data?.timeopen === 0) return false;
    const now = Math.floor(Date.now() / 1000); // thời gian hiện tại (giây)
    return now < data.timeopen;
  };

  // Hàm kiểm tra quá hạn
  const isExpired = () => {
    if (!data?.timeclose || data?.timeclose === 0) return false;
    const now = Math.floor(Date.now() / 1000); // thời gian hiện tại (giây)
    return now > data.timeclose;
  };
  return (
    <>
      <div className="quiz-card-container position-relative mb-4 quiz-card-hover" style={{
        background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)',
        padding: '20px',
        borderRadius: '20px',
        transition: 'all 0.3s ease',
        cursor: 'pointer'
      }}>
        <Link
          to={getRoute()}
          className="quiz-card-link text-decoration-none text-dark d-block"
          onClick={handleCardClick}
          state={{
            assignDuedate: data?.duedate,
            cmid: data?.cmid,
            quizName: data?.name,
            totalgrade: data?.grade,
            introAssign: data?.intro,
            filesArray: data?.introattachments || [],
          }}
        >
          <div className="quiz-card bg-white position-relative overflow-hidden" style={{
            borderRadius: '16px',
            padding: '20px',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            transition: 'all 0.3s ease'
          }}>
            {assignLoading && data?.type === "assignment" && (
              <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{
                background: 'rgba(255,255,255,0.9)',
                zIndex: 10,
                borderRadius: '16px'
              }}>
                <Spin size="large" />
              </div>
            )}


            {/* Status badge */}
            <div className="position-absolute text-white rounded-pill fw-medium status-badge" style={{
              top: '15px',
              right: '50px',
              background: data?.type === "assignment"
                ? (statusSubmissions?.lastattempt?.submission?.status === "submitted" ? '#28a745' :
                  statusSubmissions?.lastattempt?.submission?.status === "draft" ? '#ffc107' : '#6c757d')
                : (!lastAttemp ? '#17a2b8' :
                  lastAttemp?.state === "finished" ? '#28a745' :
                    lastAttemp?.state === "inprogress" ? '#ffc107' : '#6c757d'),
              padding: '4px 12px',
              fontSize: '12px',
              zIndex: 5
            }}>
              <span className="status-text">
                {data?.type === "assignment"
                  ? (isStatusSubmissions
                    ? "Đang tải..."
                    : getStatusText(statusSubmissions?.lastattempt?.submission?.status, t))
                  : (!lastAttemp
                    ? t(`quiz.card.status.new`)
                    : t(`quiz.card.status.${lastAttemp?.state}`))
                }
              </span>
              <span className="status-icon d-none">
                {data?.type === "assignment"
                  ? (statusSubmissions?.lastattempt?.submission?.status === "submitted" ?
                    <i className="isax isax-tick-circle" style={{ fontSize: '16px', color: '#28a745' }} /> :
                    statusSubmissions?.lastattempt?.submission?.status === "draft" ?
                      <i className="isax isax-edit" style={{ fontSize: '16px', color: '#ffc107' }} /> :
                      <i className="isax isax-clock" style={{ fontSize: '16px', color: '#6c757d' }} />)
                  : (!lastAttemp ?
                    <i className="isax isax-close-circle" style={{ fontSize: '16px', color: '#17a2b8' }} /> :
                    lastAttemp?.state === "finished" ?
                      <i className="isax isax-tick-circle" style={{ fontSize: '16px', color: '#28a745' }} /> :
                      lastAttemp?.state === "inprogress" ?
                        <i className="isax isax-play-circle" style={{ fontSize: '16px', color: '#ffc107' }} /> :
                        <i className="isax isax-clock" style={{ fontSize: '16px', color: '#6c757d' }} />)
                }
              </span>
            </div>

            <div className="d-flex align-items-start quiz-card-content" style={{ gap: '20px' }}>
              {/* Product Image */}
              <div className="d-flex align-items-center justify-content-center flex-shrink-0 quiz-card-image" style={{
                width: '80px',
                height: '80px',
                background: '#f8f9fa',
                borderRadius: '12px',
                border: '2px solid #e9ecef'
              }}>
                <i className="isax isax-book-1 text-muted" style={{ fontSize: '32px' }} />
              </div>

              {/* Content */}
              <div className="flex-fill" style={{ minWidth: 0 }}>
                <h5 className="mb-2 fw-semibold" style={{
                  fontSize: '18px',
                  color: '#2c3e50',
                  lineHeight: '1.3'
                }}>
                  {data?.name}
                </h5>

                {/* Course info */}
                <div>
                  <div className="d-flex align-items-center mb-1 text-muted" style={{ fontSize: '14px' }}>
                    <i className="isax isax-teacher5 me-2" style={{ fontSize: '16px' }} />
                    <span className="fw-medium">{t("quiz.card.courseLabel")}:</span>
                    <span className="ms-1">{courseName}</span>
                  </div>
                </div>


                {/* Time info */}
                <div>
                  {data?.type === "assignment" ? (
                    <>
                      <div className="d-flex align-items-center text-muted" style={{ fontSize: '14px' }}>
                        <i className="isax isax-calendar-1 me-2" style={{ fontSize: '16px' }} />
                        <span className="fw-medium">ngày cho phép nộp bài:</span>
                        <span className="ms-1">{convertTimestampToDate(data?.allowsubmissionsfromdate) || "--"}</span>
                      </div>
                      <div className="d-flex align-items-center text-muted" style={{ fontSize: '14px' }}>
                        <i className="isax isax-calendar-1 me-2" style={{ fontSize: '16px' }} />
                        <span className="fw-medium">Hạn chót:</span>
                        <span className="ms-1">{convertTimestampToDate(data?.duedate) || "--"}</span>
                      </div>
                    </>
                  ) : (
                    <div>
                      <div className="d-flex align-items-center mb-1 text-muted" style={{ fontSize: '14px' }}>
                        <i className="isax isax-timer-15 me-2" style={{ fontSize: '16px' }} />
                        <span className="fw-medium">{t("quiz.card.duration")}:</span>
                        <span className="ms-1">
                          {data?.timelimit
                            ? formatTime(data?.timelimit)
                            : "Không giới hạn thời gian"}
                        </span>
                      </div>
                      <div className="d-flex align-items-center mb-1 text-muted" style={{ fontSize: '14px' }}>
                        <i className="isax isax-timer-start5 me-2" style={{ fontSize: '16px' }} />
                        <span className="fw-medium">{t("quiz.card.openTime")}:</span>
                        <span className="ms-1">
                          {data?.timeopen === 0
                            ? "--"
                            : convertTimestampToDate(data?.timeopen) || "--"}
                        </span>
                      </div>
                      <div className="d-flex align-items-center text-muted" style={{ fontSize: '14px' }}>
                        <i className="isax isax-timer-pause5 me-2" style={{ fontSize: '16px' }} />
                        <span className="fw-medium">{t("quiz.card.closeTime")}:</span>
                        <span className="ms-1">
                          {data?.timeclose === 0
                            ? "--"
                            : convertTimestampToDate(data?.timeclose) || "--"}
                        </span>
                      </div>
                    </div>
                  )}
                </div>

              </div>
            </div>
          </div>
        </Link>
      </div>

      <Modal
        title={`Xác nhận bắt đầu bài ${data?.name}`}
        open={showConfirmModal}
        onCancel={() => setShowConfirmModal(false)}
        onOk={handleStartQuiz}
        okText="Bắt đầu ngay"
        cancelText="Hủy"
        centered
      >
        <p>Giới hạn thời gian</p>
        <p>
          Lượt làm bài của bạn sẽ có giới hạn thời gian là{" "}
          {formatTime(data?.timelimit)}. Khi bạn bắt đầu, đồng hồ đếm ngược sẽ
          khởi động và không thể tạm dừng. Bạn phải hoàn thành lượt làm trước
          khi thời gian hết.
        </p>
        <p>Bạn có chắc chắn muốn bắt đầu ngay bây giờ không?</p>
      </Modal>

      <Modal
        title="Chưa đến giờ làm bài"
        open={showNotOpenModal}
        onCancel={() => setShowNotOpenModal(false)}
        footer={null}
        centered
      >
        <p>Chưa đến giờ làm bài. Bạn không thể làm bài này lúc này.</p>
      </Modal>

      <Modal
        title="Hết thời gian làm bài"
        open={showExpiredModal}
        onCancel={() => setShowExpiredModal(false)}
        footer={null}
        centered
      >
        <p>Hết thời gian làm bài. Bạn không thể làm bài này nữa.</p>
      </Modal>
    </>
  );
};

export default QuizCard;
